module.exports = __webpack_public_path__ + "static/media/hai.77f5c095.png";